import React from 'react';
import { Box, Text } from '@chakra-ui/react';
import { LAUNCHER } from './launcherVisualTokens';

const FavoritePlaceholderTile = () => (
  <Box
    role="presentation"
    flex={`0 0 ${LAUNCHER.appTileWidth}`}
    w={LAUNCHER.appTileWidth}
    minW={LAUNCHER.appTileWidth}
    maxW={LAUNCHER.appTileWidth}
    minH={LAUNCHER.appTileMinH}
    borderRadius="lg"
    borderWidth="1px"
    borderStyle="dashed"
    borderColor="rgba(255, 255, 255, 0.12)"
    display="flex"
    alignItems="center"
    justifyContent="center"
    px={2}
    transition="border-color 0.18s ease, background 0.18s ease"
    bg="transparent"
    _hover={{
      borderColor: 'rgba(255, 255, 255, 0.2)',
      bg: 'rgba(255, 255, 255, 0.04)',
    }}
  >
    <Text
      fontSize="11px"
      fontWeight="500"
      lineHeight="1.25"
      color="rgba(255, 255, 255, 0.58)"
      textAlign="center"
      maxW="100%"
      px={0.5}
      overflowWrap="break-word"
    >
      Add below
    </Text>
  </Box>
);

export default FavoritePlaceholderTile;
